import {Helmet} from "react-helmet";
import { useSelector } from "react-redux";
import { getIsGlifeContext } from "../selectors/settings-selectors";
import { getAppMode } from "../selectors/user-selectors";
import {getContainer} from "../ioc/IOCSetup";

interface MetaHelmetProps {
  title: string;
  description: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  lang?: string;
}

const MetaHelmet: React.FC<MetaHelmetProps> = ({ title, description, keywords, ogTitle, ogDescription, ogImage, lang = "en" }) => {
    const isGlifeContext = useSelector(getIsGlifeContext);
    const isEmbeddedAppMode = useSelector(getAppMode) === "EMBEDDED";
    let appModeTitle = getContainer().getSettingsService().getAppModeTitle();
    return(
        <Helmet>
            <meta charSet="utf-8" />
            {
                isGlifeContext && isEmbeddedAppMode ? <title lang={lang}>{appModeTitle}</title> : <title lang={lang}>{title}</title>
            }
            <meta property="og:type" content="website"/>
            <meta property="og:url" content={window.location.toString()}/>
            <meta property="twitter:url" content={window.location.toString()}/>
            {description && <meta name="description" content={description} lang={lang} />}
            {keywords && <meta name="keywords" content={keywords} lang={lang}/>}
            {ogTitle && <meta property="og:title" content={ogTitle} />}
            {ogDescription && <meta property="og:description" content={ogDescription} />}
            {ogImage && <meta property="og:image" content={ogImage} />}
            {ogTitle && <meta property="twitter:title" content={ogTitle}/>}
            {ogDescription && <meta property="twitter:description" content={ogDescription}/>}
            {ogImage && <meta property="twitter:image" content={ogImage}/>}
            <meta property="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
        </Helmet>
    )

}

export default MetaHelmet;